
import { Row, Col, Container, ButtonGroup, Button, Card, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import EirButton from '../eir-button/EirButton';
import { css } from 'emotion';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";
import React, { useState, useEffect } from 'react';

function PhoneListingsTile(props) {

    const renderContent = (content) => {
        return { __html: content };
    }

    const [imagePath, setPhoneImagePath] = useState(props.tile.Phones[0].PhoneImage.path);
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [displayModel, setdisplayModel] = useState(false);

    const selectVariant = (index) => {
        setPhoneImagePath(props.tile.Phones[index].PhoneImage.path);
        setSelectedIndex(index);
    }

    const onClick = () => {
        // console.log('Index', selectedIndex);
        // console.log('image', imagePath);
        setdisplayModel(true);
    }

    const toggleModel = () => {
        setdisplayModel(false);
    }

    return (
        <div>
            <Card className="phone-listing-card">
                <div className='phone-listing-tile mb-3'>
                    <div className="phone-listing-tile-body">
                        {
                            props.tile.PhoneRoundel.roundelTitle !== '' &&
                            <div className={css`background-color: ${props.tile.PhoneRoundel.backgroundColor};` + ' roundel pl-roundel d-flex flex-column align-items-center justify-content-center position-absolute'} dangerouslySetInnerHTML={renderContent(props.tile.PhoneRoundel.roundelTitle)}></div>
                        }
                        <div>
                            {imagePath &&
                                <div className="p-0">
                                    <div className="d-flex flex-column justify-content-center align-items-center">
                                        <img className="w-100 mb-2 top-borders card-img-top" src={imagePath} alt={props.tile.AltText} />
                                    </div>
                                </div>
                            }
                        </div>
                        <div className={(isMobileOnly) ? '' : 'mb-2'}>
                            <div className="phonebrand" dangerouslySetInnerHTML={renderContent(props.tile.PhoneBrand)}></div>
                            <div className="phonemodel" dangerouslySetInnerHTML={renderContent(props.tile.PhoneModel)}></div>
                        </div>
                        {(!isMobileOnly && !isTablet) &&
                            <Row className="mb-2">
                                <div className="col-6">
                                    <ButtonGroup className={'colour-selector ml-3'} >
                                        {props.tile.Phones.map((phone, index) => (
                                            <div key={index + phone.PhoneImageColor} className="d-flex flex-column justify-content-start align-items-center">
                                                <div className='d-inline-flex btn-selected ml-1' style={(index == selectedIndex) ? { borderColor: phone.PhoneImageColor } : null}>
                                                    <Button 
                                                        onClick={() => selectVariant(index)}
                                                        style={{ backgroundColor: (phone.PhoneImageColor) }}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </ButtonGroup>
                                </div>
                                <div className="col-6">
                                    <div className="phonebrand p-2" dangerouslySetInnerHTML={renderContent(props.tile.PhonePrice)}></div>
                                </div>
                            </Row>
                        }
                        {(isMobileOnly || isTablet) &&
                            <Row className="mb-3">
                                <div className="col-12">
                                    <div className="phonebrand p-2" dangerouslySetInnerHTML={renderContent(props.tile.PhonePrice)}></div>
                                </div>
                                <div className="col-12">
                                    <ButtonGroup className={'colour-selector d-flex justify-content-center align-items-center'} >
                                        {props.tile.Phones.map((phone, index) => (
                                            <div key={index + phone.PhoneImageColor} className="d-flex flex-column justify-content-start align-items-center">
                                                <div className='d-inline-flex btn-selected ml-1' style={(index == selectedIndex) ? { borderColor: phone.PhoneImageColor } : null}>
                                                    <Button
                                                        onClick={() => selectVariant(index)}
                                                        style={{ backgroundColor: phone.PhoneImageColor }}
                                                        color="primary"
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </ButtonGroup>
                                </div>
                            </Row>
                        }
                    </div>
                </div>
                {(props.ctaImage) &&
                    <div className="p-0">
                        <div className="d-flex flex-column justify-content-center align-items-center mt-2">
                            <div role="button" onClick={onClick} className={'plus_cta card-img-bottom ' + (css`background-image: url(${(props.ctaImage) ? props.ctaImage.path : ''}); &:hover, &:active {background-image: url(${(props.ctaHoverImage) ? props.ctaHoverImage.path : ''}) !important;}`)} id={props.id}></div>
                        </div>
                    </div>
                }
            </Card>
            <Modal className="modalDialog" centered={true} isOpen={displayModel} toggle={toggleModel} >
                <ModalBody className={"modalContent " + ((isMobileOnly) ? 'p-4' : 'p-5')}>
                    {(props.ctaImage) &&
                        <img onClick={toggleModel} src={props.ctaImage.path} alt="Close" className="phonedetails-close-icon" />
                    }
                    <Row>
                        <Col sm="12" md="12" lg="4" className="d-flex justify-content-center align-items-center">
                            <img className={'mb-2 w-75'} src={imagePath} />
                        </Col>
                        <Col sm="12" md="12" lg="8" className="d-flex justify-content-center align-items-center">
                            <div>
                                <div dangerouslySetInnerHTML={renderContent(props.tile.PhoneDetails)} ></div>
                                {props.tile.PhoneDetailsCTA &&
                                    <div>
                                        <EirButton  {...props.tile.PhoneDetailsCTA} databundlecode={props.tile.id}
                                            outline={true}
                                            className={"mb-3 js-prequal-modal-btn cta_threesix ls-0 " + ((props.tile.PhoneDetailsCTA.type == 'button') ? "eir-text-secondary p-2 " + (css`background: ${props.tile.PhoneDetailsCTAColor} !important; border-color: ${props.tile.PhoneDetailsCTAOutlineColor}; color: ${props.tile.PhoneDetailsCTAFontColor} !important ; &:hover, &:focus, &:focus-within, &:active {background: ${props.tile.PhoneDetailsCTAHoverColor} !important;border-color: ${props.tile.PhoneDetailsCTAHoverColor}; color: ${props.tile.PhoneDetailsCTAFontColorHover}!important;`) : "link_threesix " + (css`color: ${props.tile.PhoneDetailsCTAFontColor} !important;`))}
                                        />
                                    </div>
                                }
                            </div>
                        </Col>
                    </Row>
                </ModalBody>
            </Modal>
        </div>
    )
}
export default PhoneListingsTile;